import wellDone from "../assets/img/certificates/wellDone.png";
import classHelper from "../assets/img/certificates/classHelper.png";
import brilliantBehaviour from "../assets/img/certificates/brilliantBehaviour.png";
import excellentAchievement from "../assets/img/certificates/excellentAchievement.png";
import fantasticFriend from "../assets/img/certificates/fantasicFriend.jpg";
import incredibleImprovement from "../assets/img/certificates/incredibleImprovement.png";
import starOfTheDay from "../assets/img/certificates/starOfTheDay.png";
import studentOfTheWeek from "../assets/img/certificates/studentOfTheWeek.png";

export const certificateOptions = [
  {
    name: "Well Done",
    value: "wellDone",
    backgroundImage: wellDone,
  },
  {
    name: "Brilliant Behaviour",
    value: "brilliantBehaviour",
    backgroundImage: brilliantBehaviour,
  },
  {
    name: "Class Helper",
    value: "classHelper",
    backgroundImage: classHelper,
  },
  {
    name: "Excellent Achievement",
    value: "excellentAchievement",
    backgroundImage: excellentAchievement,
  },
  {
    name: "Fantastic Friend",
    value: "fantasticFriend",
    backgroundImage: fantasticFriend,
  },
  {
    name: "Incredible Improvement",
    value: "incredibleImprovement",
    backgroundImage: incredibleImprovement,
  },
  {
    name: "Star Of The Day",
    value: "starOfTheDay",
    backgroundImage: starOfTheDay,
  },
  {
    name: "Student Of The Week",
    value: "studentOfTheWeek",
    backgroundImage: studentOfTheWeek,
  },
];
